<template>
    <div class="relative">
        <div class="box">
            <nav class="level">
                <b-field> </b-field>
            </nav>
            <table class="table is-fullwidth">
                <thead>
                    <tr>
                        <th>Language</th>
                        <th>Visibility</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>English</td>
                        <td>
                            <b-icon v-if="data.en" icon="check-circle" type="is-success"></b-icon>
                            <b-icon v-else icon="close-circle" type="is-danger"></b-icon>
                        </td>
                        <td>
                            <b-tooltip label="Toggle Visibility">
                                <a @click="toggleLang('en')">
                                    <b-icon v-if="data.en" icon="eye-off" type="is-primary"></b-icon>
                                    <b-icon v-else icon="eye" type="is-primary"></b-icon>
                                </a>
                            </b-tooltip>
                        </td>
                    </tr>
                    <tr>
                        <td>Arabic</td>
                        <td>
                            <b-icon v-if="data.ar" icon="check-circle" type="is-success"></b-icon>
                            <b-icon v-else icon="close-circle" type="is-danger"></b-icon>
                        </td>
                        <td>
                            <b-tooltip label="Toggle Visibility">
                                <a @click="toggleLang('ar')">
                                    <b-icon v-if="data.ar" icon="eye-off" type="is-primary"></b-icon>
                                    <b-icon v-else icon="eye" type="is-primary"></b-icon>
                                </a>
                            </b-tooltip>
                        </td>
                    </tr>
                    <tr>
                        <td>Kurdish</td>
                        <td>
                            <b-icon v-if="data.ku" icon="check-circle" type="is-success"></b-icon>
                            <b-icon v-else icon="close-circle" type="is-danger"></b-icon>
                        </td>
                        <td>
                            <b-tooltip label="Toggle Visibility">
                                <a @click="toggleLang('ku')">
                                    <b-icon v-if="data.ku" icon="eye-off" type="is-primary"></b-icon>
                                    <b-icon v-else icon="eye" type="is-primary"></b-icon>
                                </a>
                            </b-tooltip>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
    </div>
</template>

<script>
export default {
    data() {
        return {
            itemName: "Language",
            apiURI: "/languages",
            data: {},
            isLoading: true,
            stickyHead: false,
        };
    },
    methods: {
        async init() {
            this.isLoading = true;
            try {
                let res = await this.$http.get(this.apiURI);
                this.data = res.data;
            } catch (e) {
                this.notify("Error while fetching data", "is-danger");
            }
            this.isLoading = false;
        },
        toggleLang(lang) {
            this.isLoading = true;
            this.$http
                .post(`${this.apiURI}/${lang}`)
                .then((res) => (this.data = res.data))
                .catch(() => this.notify("Error while setting language", "is-danger"))
                .finally(() => (this.isLoading = false));
        },
    },
    mounted() {
        this.init();
    },
};
</script>

